import AdvancedConfigurations from './AdvancedConfigurations';

export default AdvancedConfigurations;